import { render } from "./SettingsRfcsSection.vue?vue&type=template&id=2b7aa6ac&scoped=true"
import script from "./SettingsRfcsSection.vue?vue&type=script&lang=js"
export * from "./SettingsRfcsSection.vue?vue&type=script&lang=js"

import "./SettingsRfcsSection.vue?vue&type=style&index=0&id=2b7aa6ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7aa6ac"]])

export default __exports__